import React, { Component } from "react";
import { Placeholder, Segment } from "semantic-ui-react";
import request from "../utils/request";
import PageHeader from "../components/PageHeader";
import CampaignDetails from "../components/campaign/CampaignDetails";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      eventsList: [],
      campaignList: [],
      campaignId: null
    };
  }
  startLoading = () => {
    this.setState({ loading: true });
  };
  doneLoading = () => {
    this.setState({ loading: false });
  };
  componentDidMount = async () => {
    this.startLoading();
    const result = await request.list(this, "api:/campaign");
    let active = null;
    let list = [];
    if (result.data) {
      result.data.map((c, i) => {
        if (active === null && c.status === "active") active = c;
        return list.push({
          id: c.id,
          value: c.id,
          text: c.title
        });
      });
    }
    if (active === null)
    this.setState({ campaignList: list }, this.doneLoading);
    else
    this.setState({ campaignList: list, campaignId: active.id }, this.doneLoading);
  }
  render() {
    const { campaignId, loading } = this.state;
    return (
      <Segment basic>
        <PageHeader title={"Dashboard"} breadcrumbs={[]} />
        {loading ? (
          <Placeholder>
            <Placeholder.Header>
              <Placeholder.Line length="very short" />
              <Placeholder.Line length="long" />
            </Placeholder.Header>
            <Placeholder.Paragraph />
          </Placeholder>
        ) : (
          <CampaignDetails campaignId={campaignId} />
        )}
      </Segment>
    );
  }
}

export default Dashboard;
